export const portalEn = {

  // ── Onboarding survey (/portal/onboarding) ───────────────────────────────
  onboarding: {
    title: "Welcome — how can we help you?",
    subtitle: "Tell us what brings you here so we can guide you to the right place.",
    later: "I'll do this later",
    back: "Back",
    choices: {
      applyTitle: "Apply Thailand Elite : Thailand Privilege Visa",
      applyDesc: "Start your membership / long-stay visa application.",
      memberTitle: "I'm already a Thailand Elite member",
      memberDesc: "Link your membership or request member services.",
      prospectTitle: "I have questions before deciding",
      prospectDesc: "Get information and speak with an advisor.",
      partnerTitle: "I represent an agency or partner",
      partnerDesc: "Explore partnership and referral options.",
      otherTitle: "Something else",
      otherDesc: "Another kind of request — tell us how we can help.",
      servicesTitle: "Property, insurance & other services",
      servicesDesc: "Real estate, insurance, another visa or help settling in Thailand.",
    },
    applicant: {
      heading: "A couple of quick questions",
      subtitle: "This helps us tailor your application. You can change it later.",
      purposeLabel: "What's your main reason for choosing Thailand Elite?",
      timelineLabel: "When are you planning to apply or relocate?",
      submit: "Continue to my application",
    },
    purpose: {
      retirement: "Retirement / long stay",
      business: "Business / work",
      family: "Family / dependents",
      investment: "Investment",
      lifestyle: "Lifestyle / frequent travel",
      other: "Other",
    },
    timeline: {
      asap: "As soon as possible",
      m1_3: "Within 1–3 months",
      m3_6: "In 3–6 months",
      m6_12: "In 6–12 months",
      exploring: "Just exploring for now",
    },
    member: {
      heading: "Welcome back — let's find your membership",
      subtitle: "Share your member ID and our team will link it to this account after a quick verification.",
      idLabel: "Member ID / card number",
      idPlaceholder: "e.g. TPC123456",
      sinceLabel: "When did you become a member?",
      sincePlaceholder: "e.g. 2022",
      viaLabel: "How did you apply?",
      viaPlaceholder: "Agent, direct, etc.",
      helpLabel: "How can we help?",
      helpPlaceholder: "Describe your request (visa affix, 90-day report, renewal…).",
      submit: "Submit",
    },
    inquiry: {
      heading: "Tell us a bit more",
      subtitle: "We'll get your request to the right person and follow up.",
      typeLabel: "What is your request about?",
      messageLabel: "Your message",
      messagePlaceholder: "Tell us how we can help you.",
      submit: "Submit request",
    },
    inquiryTypes: {
      general_inquiry: "General question",
      member_service: "Existing member — service request",
      partnership: "Agency / partnership",
      visa_other: "Other visa / immigration question",
      other_services: "Property, insurance or other services",
      other: "Other",
    },
    services: {
      heading: "What can we help you with?",
      subtitle: "Pick everything that interests you — we'll connect you with the right partner.",
      interestsLabel: "I'm interested in",
      messageLabel: "Anything to add?",
      messagePlaceholder: "e.g. looking for a condo in Bangkok, health insurance for two…",
      submit: "Send",
      needInterestTitle: "Pick at least one option",
      needInterestDesc: "Tell us what you're interested in.",
    },
    interests: {
      real_estate: "Real estate",
      insurance: "Health / travel insurance",
      other_visa: "Another visa",
      business_setup: "Company / business setup",
      relocation: "Relocation help (schools, banking…)",
      extraLabel: "Anything else we can help you with in Thailand?",
    },
    deleteAccount: {
      link: "Created this account by mistake? Delete it",
      title: "Delete your account?",
      desc: "Your account and the information you entered will be permanently deleted. This cannot be undone.",
      confirm: "Delete my account",
      cancel: "Cancel",
      doneTitle: "Account deleted",
      doneDesc: "Your account has been deleted. You're welcome back anytime.",
      failedTitle: "Could not delete the account",
      notEligible: "This account has an application or a membership. Send us a message and we'll close it for you.",
    },
    done: {
      title: "Your request has been submitted",
      desc: "Thank you — our team will review it and contact you shortly.",
      cta: "Go to my dashboard",
    },
    optionalTag: "(optional)",
    memberOutcome: {
      linkedTitle: "Membership linked ✓",
      linkedDesc: "Welcome back — your member area is ready.",
      pendingTitle: "Almost there — confirm your membership",
      pendingDesc: "We've sent a confirmation to your email on file ({{email}}). Once you confirm and our team approves, your membership will be linked.",
    },
    banner: {
      memberTitle: "Thanks — we're verifying your membership",
      memberDesc: "Our team will link your member ID to this account shortly. You'll be notified once it's confirmed.",
      prospectTitle: "Thanks for reaching out",
      prospectDesc: "An advisor will follow up with the information you requested. Ready to apply? You can start anytime below.",
      partnerTitle: "Thanks for your interest in partnering",
      partnerDesc: "Ready to partner with us? Submit your company profile to get started — or our partnerships team will reach out.",
      partnerCta: "Become a partner",
      otherTitle: "Your request has been received",
      otherDesc: "Our team will review it and follow up with you shortly.",
    },
    toast: {
      saveFailedTitle: "Could not save",
      saveFailedDesc: "Please try again.",
      applicantOkTitle: "Great — let's get started",
      applicantOkDesc: "You can now begin your application.",
      needMessageTitle: "Please add a short message",
      needMessageDesc: "Tell us how we can help.",
    },
  },
  // ── Common ──────────────────────────────────────────────────────────────
  common: {
    saveAndContinue: "Save & Continue",
    back: "Back",
    submit: "Submit Application",
    submitting: "Submitting…",
    saving: "Saving…",
    uploading: "Uploading…",
    required: "Required",
    optional: "optional",
    yes: "Yes",
    no: "No",
    select: "Select…",
    uploaded: "Uploaded",
    missing: "Missing",
    loading: "Loading…",
    download: "Download",
    upload: "Upload",
    remove: "Remove",
    retry: "Retry",
    next: "Next",
    close: "Close",
    addDocuments: "Add documents",
    signOut: "Sign Out",
    memberPortal: "Member Portal",
    language: "Language",
    // Toast messages
    fileTooLarge: "File too large",
    maxSizeAllowed: "Max {{size}} allowed.",
    uploadFailed: "Upload failed",
    invalidEmail: "Invalid email",
  },

  // ── Dashboard ────────────────────────────────────────────────────────────
  dashboard: {
    myApplications: "My Applications",
    nextMemberApp: "Next Member Application",
    addNextMember: "Add Next Member",
    nextMemberPromo: "Promotion: THB 750,000 per Next Member until 31/12/2026",
    noApplications: "No applications yet",
    noApplicationsDesc: "Start your Thailand Elite journey by creating your first application.",
    createApplication: "Create Application",
    newApplication: "New Application",
    resumeApplication: "Resume Application",
    alreadyActiveTitle: "Application already in progress",
    alreadyActiveDesc: "You already have an active application. Please complete or cancel it before starting a new one.",
    package: "Package",
    created: "Created",
    messages: "Messages",
    newThread: "New Thread",
    newThreadSubject: "Subject",
    newThreadBody: "Message",
    generalInquiry: "General Inquiry",
    noMessages: "No messages yet",
    status: {
      open: "Open",
      waiting_reply: "Waiting Reply",
      closed: "Closed",
      draft: "Draft",
      submitted: "Submitted",
      under_review: "Under Review",
      background_check: "Background Check",
      approved: "Approved",
      payment_pending: "Payment Pending",
      payment_done: "Waiting for Activation",
      active: "Active",
      cancelled: "Cancelled",
      rejected: "Rejected",
    },
  },

  // ── Member Area ──────────────────────────────────────────────────────────
  membership: {
    card: {
      sectionTitle: "Your Membership Card",
      tierLabel:    "Membership",
      holderLabel:  "Card Holder",
      numberLabel:  "Card Number",
      validFrom:    "Valid From",
      validUntil:   "Valid Until",
      printOrSave:  "Print or save as PDF",
    },
    documents: {
      lettersTitle:                "Official Letters",
      welcomeLetter:               "Welcome Letter",
      welcomeLetterDesc:           "Your official Thailand Elite welcome letter",
      welcomeLetterPending:        "Will be uploaded by your agent upon activation confirmation",
      certificationLetter:        "Certification Letter",
      certificationLetterDesc:    "Official Thailand Privilege certification document",
      certificationLetterPending: "Available once issued by Thailand Privilege",
      pending:                    "Pending",
    },
  },

  // ── Member Services / Service Requests ───────────────────────────────────
  services: {
    tabLabel:           "Services",
    title:              "Member Services",
    intro:              "Submit a service request — visa affix, 90-day notification, or any other inquiry. Your member ID is attached automatically.",
    chooseType:         "Choose a service",
    noTypes:            "No service types available right now. Please contact support.",
    estimated:          "~{{days}} working days",
    history:            "Your previous requests",
    back:               "Back to services",
    requirementsTitle:  "What you need to provide",
    memberIdLabel:      "Submitting as",
    subject:            "Subject",
    messageLabel:       "Describe your request",
    messagePlaceholder: "Add any details that will help us process your request faster.",
    attachments:        "Attachments",
    addFile:            "Click to upload (PDF / JPG / PNG, max 10 MB)",
    send:               "Send Request",
    submittedTitle:     "Request submitted",
    submittedDesc:      "Our Member Services team will review and reply via Messages.",
    submittedDescMcc:      "Our team will review it and reply via Messages. For faster processing, send the ready-made email to the MCC below.",
    mcc: {
      title: "Contact the MCC directly",
      intro: "The Thailand Privilege Member Contact Center (MCC) books this service. Send them this ready-made email in English from your own mailbox: we receive a copy and follow up for you.",
      titleNext: "Speed up your request: email the MCC",
      recommended: "Recommended · faster processing",
      oneMinute: "It takes a minute: the email is ready, just press send.",
      attachReminder: "Your documents are not added automatically (privacy). Please attach them to your email: {{files}}",
      linksIncluded: "Your documents are included in the email as secure links (valid until {{date}}). You can also attach them.",
      copyTip: "Tip: use “Copy the email” and paste it into your mailbox, the file names become clickable links.",
      emailButton: "Email the MCC",
      gmailButton: "Open in Gmail",
      callButton: "Call the MCC",
      copyButton: "Copy the email",
      copied: "Email copied.",
      preview: "Show the email",
      hidePreview: "Hide the email",
      confirmEmailTitle: "Did you send your email to the MCC?",
      confirmPhoneTitle: "Did you reach the MCC?",
      confirmHint: "The MCC usually replies within a few hours. For urgent matters, send the email and also call {{phone}}.",
      yes: "Yes",
      notYet: "Not yet",
      statusEmail: "You emailed the MCC on {{date}}.",
      statusPhone: "You called the MCC on {{date}}.",
      copyReceived: "We received the copy of your email.",
      followupTitle: "Did you get an answer from the MCC?",
      answered: "Yes, it's sorted",
      needHelp: "No, I need help",
      thanks: "Thank you, noted.",
      helpSent: "We're on it: our team will follow up with the MCC for you.",
      packageTitle: "Your membership: {{package}}",
      privilegePoints: "Privilege Points",
      privilegeBook: "2026 Privilege Book (PDF)",
      mccLine: "Member Contact Center: {{email}} · {{phone}}",
      done: "Done",
    },
    details: {
      whereTitle: "Where do you want your visa affixed?",
      airport: "At the airport, on arrival",
      airportHint: "Arrival at least 7 days from today. Have your flight ticket ready.",
      chaeng: "At Chaeng Watthana Immigration, Bangkok",
      chaengHint: "A working day at least 5 working days from today. A TM30 copy is required.",
      arrivalAirport: "Arrival airport",
      flightNumber: "Flight number",
      departureFrom: "Departing from",
      departurePlaceholder: "e.g. Paris CDG",
      arrivalDate: "Arrival date",
      arrivalTime: "Arrival time (local)",
      ticket: "Flight ticket or itinerary",
      ticketHint: "PDF or photo. We check that it matches the flight above.",
      ticketChecking: "Checking your ticket…",
      ticketMatch: "Ticket checked: flight and date match.",
      ticketMismatch: "Please check your ticket:",
      ticketUnreadable: "We couldn't read the ticket automatically. Our team will check it.",
      preferredDate: "Preferred date",
      period: "Time of day",
      morning: "Morning (9:00–12:00)",
      afternoon: "Afternoon (13:00–16:00)",
      alternativeDate: "Second choice (optional)",
      tentative: "Dates are tentative and confirmed by Member Services, subject to availability.",
      tm30: "TM30 copy (proof of address)",
      tm30Hint: "The TM30 receipt from your landlord or hotel.",
      passportCopy: "Passport copy (photo page)",
      passportHint: "The passport your visa will be affixed in. If you have a new passport, upload it instead.",
      passportFromApplication: "From your application",
      useApplicationPassport: "Use the passport from my application",
      passportNewWarning: "This is not the passport you applied with. With a new passport, Immigration may need to run the background check again before the visa can be affixed, which can take extra time. We will let you know if anything else is needed.",
      tm30Guide: "What is the TM30?",
      upload: "Upload",
      replace: "Replace",
      bank: "Bank",
      bankPlaceholder: "Choose a bank",
      city: "City",
      branch: "Branch (optional)",
      branchPlaceholder: "e.g. Silom, Central World",
      bankHint: "The bank makes the final decision and may ask for more documents.",
      ninetyTitle: "About the 90-day report",
      ninetySummary: "Form TM47 confirms your address every 90 days of continuous stay. Leaving Thailand resets the count. It can be filed from 15 days before to 7 days after the due date; late filing is fined THB 2,000.",
      readGuide: "Read the full guide",
      messageOptional: "Anything else we should know?",
      noMessage: "See the details below.",
      licenseType: "Licence type",
      car: "Car",
      motorcycle: "Motorcycle",
      both: "Car and motorcycle",
      office: "Department of Land Transport office",
      chatuchak: "Chatuchak, Bangkok",
      otherOffice: "Another office",
      otherOfficePlaceholder: "City / office",
      homeLicense: "Your valid home-country driving licence",
      residenceCertificate: "Residence certificate",
      residenceCertificateHint: "Issued by your embassy (or a work permit).",
      medicalCertificate: "Medical certificate",
      medicalCertificateHint: "From a clinic in Thailand, issued within the last month. It can also be obtained before the appointment.",
      drivingIntro: "Done in one day at the Department of Land Transport with our liaison. Bring your passport with the Privilege visa.",
      drivingGuide: "Driving licence guide",
      epaService: "Service",
      epaArrival: "Arrival",
      epaDeparture: "Departure",
      epaAirport: "Airport",
      flightDate: "Flight date",
      flightTime: "Flight time (local)",
      originCity: "Origin city",
      originCityPlaceholder: "e.g. Paris",
      passengers: "Number of passengers",
      epaHint: "EPA operates 06:00–24:00. Book at least 5 hours before your flight.",
      optional: "optional",
      docType: "Document type",
      docTypes: {
        passport: "Passport",
        visa_page: "Visa page",
        photo: "Photo",
        entry_stamp: "Entry stamp",
        tm30: "TM30",
        flight_ticket: "Flight ticket",
        home_license: "Driving licence (home country)",
        residence_certificate: "Residence certificate",
        medical_certificate: "Medical certificate",
        other: "Other document",
      },
      phone: "Phone number (for the MCC)",
      phoneHint: "From your profile. You can change it.",
      fromApplication: "Add from my application",
      fromApplicationHint: "Documents you already uploaded with your application. No need to upload them again.",
      appDocs: {
        passport_photo: "Passport photo page",
        passport_signature: "Passport signature page",
        visa: "Visa page",
        arrival_stamp: "Entry stamp",
        profile_photo: "Photo",
        marriage_certificate: "Marriage certificate",
        birth_certificate: "Birth certificate",
      },
      errors: {
        licenseTypeRequired: "Choose the licence type.",
        officeRequired: "Choose the office.",
        homeLicenseRequired: "Upload your home-country driving licence.",
        residenceCertificateRequired: "Upload your residence certificate.",
        epaServiceRequired: "Choose arrival or departure.",
        flightDateRequired: "Enter the flight date.",
        flightDatePast: "The flight date is in the past.",
        flightTimeRequired: "Enter the flight time.",
        epaTooSoon: "EPA must be booked at least 5 hours before the flight.",
        originCityRequired: "Enter the origin city.",
        locationRequired: "Choose where you want the visa affixed.",
        airportRequired: "Choose the arrival airport.",
        flightNumberInvalid: "Enter the flight number, e.g. TG931.",
        arrivalDateRequired: "Enter the arrival date.",
        arrivalTooSoon: "Arrival must be on {{date}} or later (7 days from today).",
        arrivalTimeRequired: "Enter the arrival time.",
        preferredDateRequired: "Choose a preferred date.",
        weekend: "Immigration is closed on weekends. Choose Monday to Friday.",
        appointmentTooSoon: "Choose {{date}} or later (5 working days from today).",
        periodRequired: "Choose morning or afternoon.",
        alternativeInvalid: "The second choice must be a working day, {{date}} or later.",
        tm30Required: "Upload a copy of your TM30.",
        passportRequired: "Attach a copy of your passport.",
        bankRequired: "Choose a bank.",
        cityRequired: "Choose a city.",
      },
    },
  },

  // ── Application Wizard ───────────────────────────────────────────────────
  wizard: {
    applicationSteps: "Application Steps",
    step: "Step",
    of: "of",
    readOnlyBanner: "This application has been submitted. Contact support to request changes.",
    readOnlySupportLink: "Request a change",
    backgroundCheckTitle: "Application Under Review",
    backgroundCheckBody: "Your application is currently being reviewed by our team and the relevant Thai authorities. At this stage, your application cannot be cancelled or modified. If you have any questions, please contact our support team.",
    backgroundCheckExpected: "You may receive your approval letter by approximately:",
    backgroundCheckNote: "* This is an estimated timeframe based on typical processing of 4–8 weeks. It is not guaranteed.",
    backgroundCheckContact: "For questions, contact our team:",
    steps: {
      package: "Package",
      passport: "Passport",
      personalInfo: "Personal Info",
      address: "Address",
      visa: "Visa & Entry",
      documents: "Documents",
      review: "Review",
    },
    stepDescriptions: {
      package: "Select your Thailand Elite membership package",
      passport: "Upload and verify your passport",
      personalInfo: "Complete your personal information",
      address: "Your residential address and contact details",
      visa: "Current visa and entry status",
      documents: "Upload and sign required documents",
      review: "Review and submit your application",
    },
  },

  // ── Next Member ──────────────────────────────────────────────────────────
  nextMember: {
    title: "Next Member Application",
    subtitle: "You are applying as a next member under an existing core membership.",
    badge: "Next Member",
    addButton: "Add Next Member",
    relationship: "Relationship to core member",
    selectRelationship: "Select relationship…",
    relationships: {
      spouse: "Spouse",
      child: "Child",
      parent: "Parent",
      adopted_child: "Adopted Child",
      civil_union: "Civil Union Partner",
    },
    coreApplication: "Core application",
    additionalFee: "Additional member fee",
    promoLabel: "Promotional rate",
    regularFee: "Regular fee",
    promoUntil: "Valid until 31/12/2026",
    perMember: "/member",
    existingNextMember: "Next member application",
  },

  // ── Step 1 — Package ─────────────────────────────────────────────────────
  package: {
    title: "Choose Your Package",
    subtitle: "Select the Thailand Elite membership program that suits you best.",
    selected: "Selected",
    selectPackage: "Select Package",
    years: "years",
    perYear: "per year",
    includes: "Includes",
    familyOption: "Family option available",
  },

  // ── Step 2 — Passport ────────────────────────────────────────────────────
  passport: {
    title: "Passport Verification",
    subtitle: "Upload your passport identity page for OCR verification.",
    uploadTitle: "Upload Passport Photo",
    uploadDesc: "Photo or scan of your passport identity page (JPG, PNG, PDF — max 10MB)",
    uploadHint: "Tap to upload or take a photo",
    extractTitle: "Extract Passport Data",
    extractDesc: "Click to auto-fill your details with AI — takes a few seconds",
    retakePhoto: "Retake / Re-upload",
    passportNumber: "Passport Number",
    surname: "Surname",
    givenName: "Given Name(s)",
    nationality: "Nationality",
    dateOfBirth: "Date of Birth",
    sex: "Sex",
    dateOfIssue: "Date of Issue",
    dateOfExpiry: "Date of Expiry",
    placeOfBirth: "Place of Birth",
    mrz: "Machine Readable Zone (MRZ)",
    extractedData: "Extracted Data",
    verifyAndContinue: "Verify & Continue",
    lowConfidenceWarning: "Some fields could not be read clearly. Please review before continuing.",
    expiryWarning: "Your passport must be valid for at least 6 months to apply.",
    expiryModalTitle: "Passport Validity Issue",
    expiryModalDesc: "Your passport validity must be over 1 year from the application date. Please renew your passport before applying.",
    expiryModalCta: "I understand",
    // Scan requirements
    scanRequirements: "Scan Requirements",
    scanReqColor: "Full color scan — no black & white",
    scanReqEdges: "All four edges visible",
    scanReqResolution: "High resolution, all text readable",
    scanReqFocus: "Not blurry or out of focus",
    gallery: "Gallery",
    scanning: "Scanning…",
    uploadDifferentFile: "Upload a different file",
    fileFormatHint: "JPG, PNG or PDF · max 10 MB",
    // Gender options
    male: "Male",
    female: "Female",
    // Placeholders
    cityOrTown: "City or town",
    country: "Country",
    asShownOnPassport: "As shown on passport",
    ifApplicable: "If applicable",
    // Toast messages
    passportUploaded: "Passport uploaded",
    passportUploadedDesc: "Click 'Scan & Prefill with AI' to extract your data.",
    passportScanned: "Passport scanned ✓",
    passportScannedDesc: "Review the extracted data below.",
    qualityIssuesDetected: "Quality issues detected",
    scanUnavailable: "Scan unavailable",
    scanUnavailableDesc: "Please fill in your details manually below.",
    applicationAlreadyExists: "Application already exists",
    applicationAlreadyExistsDesc: "A previous application for {{name}} was already started. Please resume it or contact support if this is a new applicant.",
    // OCR quality issues
    blurryImage: "Blurry image",
    reflectionDetected: "Reflection / glare detected",
    glareOnPassport: "Glare on passport",
    imageCropped: "Image cropped — re-scan showing full passport",
    bioPageComplete: "Bio page complete",
    mrzReadable: "MRZ readable",
    // Signature section
    signaturePage: "Signature Page",
    signatureOptional: "Optional",
    signaturePageRequired: "Upload the page of your passport that contains your handwritten signature if not in your Bio Page.",
    signatureDetectedOnBio: "Your signature was detected on the bio data page. You may also upload the separate signature page if your passport has one.",
    signatureDetectedConfirm: "Signature detected on passport bio page ✓",
    signatureDetectedNote: "If your passport also has a dedicated signature page (common in French, Italian, German passports), you may upload it below.",
    signatureNotCorrect: "Not correct — no signature on this page",
    noSignatureOnBioPage: "No signature found on bio page",
    noSignatureOnBioPageNote: "Some passports do not include a signature on the data page — please upload the page that contains your signature. This is required for passports from: <strong>Singapore, Philippines, Malaysia, Indonesia, Sweden, UAE, Saudi Arabia, Qatar, Kuwait, Bahrain, Oman</strong>, and most children's passports.",
    signaturePageUploaded: "Signature page uploaded",
    uploadSignaturePageOptional: "Upload Signature Page (Optional)",
    uploadSignaturePage: "Upload Signature Page",
    replace: "Replace",
    pdf: {
      label: "Passport PDF",
      openPreview: "Open PDF preview",
      detectedNote: "PDF detected — the passport page is read directly from the PDF.",
    },
    ocrCooldown: "Please wait a few seconds before retrying.",
  },

  // ── Step 3 — Personal Info ───────────────────────────────────────────────
  personalInfo: {
    title: "Personal Information",
    subtitle: "Review and complete your profile and application details.",
    profilePhoto: {
      title: "Profile ID Photo",
      desc: "A clear, recent photo of your face (passport-style). Required for your membership card.",
      uploadButton: "Upload Photo",
      changeButton: "Change Photo",
      takePhoto: "Take Photo",
      saved: "Saved",
      photoSaved: "Photo saved ✓",
      photoUploadFailed: "Photo upload failed",
      removeBackgroundAi: "Remove background with AI",
      removeBackgroundNote: "Background will be replaced with white — applied on next upload.",
    },
    identity: {
      sectionTitle: "Identity",
      title: "Title",
      givenName: "Given Name",
      middleName: "Middle Name",
      surname: "Surname",
      nameOnCard: "Name on Elite Card",
      nameOnCardHint: "Name to appear on your membership card",
      dateOfBirth: "Date of Birth",
      gender: "Sex / Gender",
      occupation: "Occupation",
      businessIndustry: "Business Industry",
    },
    applicationDetails: {
      sectionTitle: "Application Details",
      sectionDesc: "Pre-filled from your passport scan. Passport data automatically overrides when detected.",
      fromPassport: "From passport",
      nationality: "Nationality",
      placeOfBirth: "Place of Birth",
      countryOfBirth: "Country of Birth",
    },
    nationalityCheck: {
      question: "Do you currently hold any other nationality or citizenship?",
      otherNationality: "Other nationality",
      passportsIntro: "Declare every other passport and nationality you hold. These details are printed on the Multiple Passports and Nationalities Declaration (page 2 of your application form), which you will sign.",
      passportHeading: "Other passport {{n}}",
      passportNumber: "Passport number",
      issueDate: "Issue date",
      expiryDate: "Expiry date",
      nameOnPassport: "Full name on this passport (if different)",
      addPassport: "Add another passport",
      passportRequired: "Please enter the nationality and passport number of your other passport.",
      requiredDocsTitle: "Required documents for applicants with multiple nationalities:",
      reqDoc1: "Passport(s) of your original nationality, plus any previous passport(s) if your name or surname has changed.",
      reqDoc2: "Official document(s) showing the renunciation of your original nationality (if applicable).",
      reqDoc3: "Documents verifying your income and the source of funds used for the membership application.",
      reqDoc4: "Proof of permanent residence in Thailand or abroad covering the past 6 months.",
      mismatchTitle: "Country of birth differs from your nationality",
      mismatchIntro: "We also noticed that your country of birth is different from your country of citizenship, while you indicated that you currently hold only one nationality.",
      mismatchBody: "Please be advised that Immigration authorities have strict requirements for visa affixation and may request additional documentation. If you hold dual nationality, you must disclose it. If you have renounced a previous nationality, please prepare the relevant supporting documents.",
      listTitle: "If applicable, please provide:",
      doc1: "A clear copy of your second passport.",
      doc2: "A copy of your citizenship certificate or other documentation showing how you obtained your current citizenship, together with a brief explanation.",
      doc3: "A copy of your renunciation certificate if you previously held another nationality and have since renounced it.",
      explanationLabel: "Brief explanation (optional)",
      explanationPlaceholder: "e.g. Born in Brazil, naturalised French in 2010, Brazilian nationality renounced in 2012.",
      uploadTitle: "Supporting documents",
      uploadDesc: "PDF, JPG or PNG — up to 10 MB each.",
    },
    contact: {
      phone: "Phone / Telephone",
      phonePlaceholder: "+66 XX XXX XXXX",
      email: "Email Address",
      emailHint: "Used for your application. Can differ from your login email.",
    },
    sharedProfile: "Shared profile",
    fillAllRequiredFields: "Please fill in all required fields",
  },

  // ── Step 4 — Address ─────────────────────────────────────────────────────
  address: {
    title: "Address",
    subtitle: "Your current residential address.",
    currentAddress: "Current Address",
    street: "Street Address",
    streetHint: "OpenStreetMap autocomplete",
    startTyping: "Start typing your address…",
    city: "City",
    state: "State / Province",
    country: "Country",
    postalCode: "Postal Code",
    thaiAddress: "Thailand Address",
    haveThaiAddress: "I have a Thailand address",
    accommodationType: "Accommodation Type",
    province: "Province",
    district: "District",
    subDistrict: "Sub-District",
    thaiTelephone: "Telephone (Thailand)",
    thaiPhoneNote: "Thailand phone number (without leading 0)",
    validationError: "Please fill Street, City and Country",
  },

  // ── Step 5 — Visa & Entry ────────────────────────────────────────────────
  visa: {
    title: "Visa & Entry Status",
    subtitle: "Your current Thai visa and entry information.",
    currentVisa: "Current Thai Visa",
    hasThaiVisa: "Are you currently holding a Thai visa?",
    visaType: "Visa Type",
    visaExpiry: "Visa Expiry Date",
    uploadVisaPage: "Photo of visa page",
    uploadVisaBtn: "Upload visa page",
    arrivalStamp: "Arrival Stamp",
    hasArrivalStamp: "Are you currently holding an Arrival Stamp?",
    stampExpiry: "Arrival Stamp Expiry Date",
    uploadStampPage: "Photo of arrival stamp page",
    uploadStampBtn: "Upload arrival stamp page",
    passportStatus: "Passport Status",
    blankVisaPages: "More than 3 blank visa pages in your passport?",
    blankYes: "Yes — more than 3",
    blankNo: "No — 3 or fewer",
    overstayCount: "Times overstayed in Thailand (past 3 years)",
    overstayNever: "0 — Never",
    otherVisaOption: "Other (please specify)",
    otherVisaLabel: "Please specify your visa",
    otherVisaPlaceholder: "Short code, e.g. Non-O, SMART-T",
    edVisa: {
      sectionTitle: "Education Visa (ED) History",
      sectionDesc: "Required declaration for Thailand Elite eligibility assessment.",
      question: "Do you have a history of Education Visa (ED) in the past 5 years or in your current passport?",
      warningTitle: "Additional supporting documents required",
      warningDesc: "Acceptance of applicants with Education Visa records is subject to submission of the following documents. Missing documents may result in refusal.",
      doc1: "School Establishment License (สช.2 / OBEC / OPEC)",
      doc2: "School registration (ร.2)",
      doc3: "Student Certification from school",
      doc4: "Academic Record, grade reports and attendance record",
      doc5: "Class Activities photos",
      doc5Optional: "(optional — upload later if unavailable)",
      acknowledgementForm: "Acknowledgement Form",
      acknowledgementFormDesc: "Download, fill in and upload with your supporting documents",
      uploadTitle: "Upload supporting documents",
      uploadDesc: "PDF, JPG or PNG — you can upload multiple files. Saved securely to your application.",
    },
  },

  // ── Visa validity reminder (shown in VisaStep + ReviewStep) ─────────────
  visaReminder: {
    title: "Important — Maintain a valid visa",
    body: "Please maintain a valid visa at all times if you are in Thailand. Submitting this application does not grant you any extension of stay or permission to remain in Thailand. If you are currently in Thailand, please ensure your visa remains valid throughout the application process.",
  },

  // ── Step 6 — Documents ───────────────────────────────────────────────────
  documents: {
    title: "Documents",
    subtitle: "Download, sign and upload your application forms.",
    applicationForm: {
      title: "Application Form",
      desc: "Download your pre-filled application form, sign it digitally, then upload it.",
      download: "Download Pre-filled PDF",
      signDigitally: "Sign Digitally",
      signatureCapture: "Capture Signature",
      signatureCaptureDesc: "Draw your signature below",
      clear: "Clear",
      save: "Save Signature",
      appliedTo: "Applied to all pages",
      uploadSigned: "Upload Signed Form",
    },
    pdpaForm: {
      title: "PDPA Consent Form",
      desc: "Personal Data Protection Act consent. Download, sign and upload.",
      download: "Download PDPA Form",
      signDigitally: "Sign Digitally",
      uploadSigned: "Upload Signed Form",
    },
    uploadStatus: "Upload Status",
    viewDocument: "View uploaded document",
    downloadDocument: "Download signed PDF",
    signingComplete: "Signing complete — upload to save",
    remaining: "remaining",
    requiredDocuments: "Required Documents",
    continueToReview: "Continue to Review",
    blankForm: "Blank form",
    blankAddendum: "Blank promo addendum",
    downloadLabel: "Download",
    reprefill: "Re-prefill",
    // Toast messages for DocumentsStep
    applicationFormPrefilled: "Application Form prefilled",
    applicationFormPrefilledDesc: "Downloaded! Sign every page, then upload or sign digitally.",
    prefillFailed: "Prefill failed",
    applicationFormSigned: "Application Form signed and saved ✓",
    signingFailed: "Signing failed",
    applicationFormUploaded: "Application Form uploaded ✓",
    pdpaFormSigned: "PDPA Consent Form signed and saved ✓",
    pdpaFormUploaded: "PDPA Consent Form uploaded ✓",
    documentUploaded: "Document uploaded ✓",
    uploaded: "Uploaded ✓",
    translationUploaded: "Translation uploaded ✓",
    uploadTranslation: "Upload translation",
    relationshipProof: {
      title: "Relationship Proof Documents",
      subtitle: "Upload official documents proving your relationship to the core member.",
      marriageCert: "Marriage Certificate",
      birthCert: "Birth Certificate",
      adoptionCert: "Adoption Certificate",
      civilUnionCert: "Civil Union Certificate",
      notInEnglish: "This document is not in English",
      certifiedTranslation: "Certified English Translation",
    },
    signatureCapture: {
      title: "E-Signature (Optional)",
      subtitle: "Draw or upload your signature to apply to all application documents.",
      saved: "Signature saved",
      willBeApplied: "Will be applied to all documents",
      confirm: "I understand and wish to sign digitally",
      disclaimer1: "The applicant must personally sign all pages of the application. If the applicant is under 20 years old, the legal representative must also sign.",
      disclaimer2: "All signatures must match the signature on the passport exactly.",
      disclaimer3: "⚠️ We allow digital signatures, but please understand that in some cases Thailand Privilege Card may request a fully printed, hand-signed, and scanned copy of all pages. If you have a printer and scanner, we strongly recommend printing and signing by hand.",
      options: {
        upload: {
          title: "Upload Signature",
          desc: "Upload an image of your signature",
          instruction: "Click or drag an image file here",
          enhancing: "Enhancing…",
          clickToUpload: "Click to upload",
        },
        passport: {
          title: "Use Passport Signature",
          desc: "Extract your signature from your uploaded passport scan",
          passportRef: "Passport scan",
          notFound: "No passport scan found — please upload your passport first",
          instruction: "Click to extract signature from passport",
          uploadBtn: "Extract from Passport",
        },
        draw: {
          title: "Draw Signature",
          desc: "Draw your signature using your mouse or finger",
        },
      },
    },
  },

  // ── Step 7 — Review ───────────────────────────────────────────────────────
  review: {
    title: "Review & Submit",
    subtitle: "Review your application before submitting.",
    applicationSummary: "Application Summary",
    membershipPackage: "Membership Package",
    fullName: "Full Name",
    nationality: "Nationality",
    dateOfBirth: "Date of Birth",
    passportNo: "Passport No.",
    passportExpiry: "Passport Expiry",
    occupation: "Occupation",
    country: "Country",
    city: "City",
    phone: "Phone",
    email: "Email",
    remaining: "remaining",
    requiredDocuments: "Required Documents",
    passportPhoto: "Passport / ID photo",
    profilePhoto: "Profile photo",
    applicationFormSigned: "Application Form (signed)",
    pdpaFormSigned: "PDPA Consent Form (signed)",
    missingDocsWarning: "Please complete all required documents in Step 6 before submitting.",
    // Validation issues
    validation: {
      fullNameMissing: "Full name missing",
      passportNoMissing: "Passport number missing",
      passportExpiryMissing: "Passport expiry date missing",
      passportValidityWarning: "Passport validity must be over 1 year from application date",
      nationalityMissing: "Nationality missing",
      otherNationalityMissing: "Second-nationality question not answered",
      phoneMissing: "Phone number missing",
      countryMissing: "Country of residence missing",
      cityMissing: "City missing",
      missingInfoTitle: "Missing information — please complete before submitting",
      goTo: "Go to",
      completeBeforeSubmitting: "Please complete the missing information above before submitting",
      accountFlaggedTitle: "Your account has been flagged",
      uploadFlagged: "One of your uploads does not meet our document rules, so your account has been flagged for review. If this is a mistake, send us a message and our team will check it.",
      contactUs: "Send us a message",
      passportNotGenuine: "The uploaded file is not a readable passport bio-data page (the page with your photo and the two lines of code at the bottom). Please upload a clear copy of your real passport.",
      passportDataMismatch: "Some details do not match your scanned passport: {{fields}}. Please correct them so they match your passport exactly.",
      mismatchConfirm: "My details are correct — please let the team check my passport",
      fieldPassportNo: "passport number",
      fieldDob: "date of birth",
      fieldExpiry: "passport expiry date",
    },
    survey: {
      title: "Survey",
      howDidYouLearn: "How did you learn about Thailand Elite?",
      mainReason: "Main reason for applying?",
      expectation: "What do you expect from the membership?",
    },
    agreement: "I confirm that all information provided is accurate, complete, and authentic. I consent to the processing of my personal data and documents — including AI-assisted passport OCR and signature verification — by Dreamond and Thailand Privilege Card Co., Ltd. for the purpose of my membership application. I understand that no payment is required until my application is officially approved, and that any payment must be made exclusively to Thailand Privilege Card Co., Ltd. based on their official invoice. I have read and agree to the",
    termsAndConditions: "Terms & Conditions",
    and: "and",
    privacyPolicy: "Privacy Policy",
    noPaymentNote: "no payment is required until my application is officially approved",
    missingDocumentsError: "Missing documents",
    missingDocumentsErrorDesc: "Please upload all required documents before submitting.",
    submittedTitle: "Application submitted!",
    submittedDesc: "We'll review your application and get back to you.",
    submissionFailed: "Submission failed",
  },

  // ── Auth pages ────────────────────────────────────────────────────────────
  // ── Post-Approval Screens ─────────────────────────────────────────────────
  screens: {
    common: {
      contactSupport: "For questions, contact our team:",
    },
    approved: {
      title: "Congratulations! Your application has been approved",
      message: "Please check your email for the approval letter and invoice. You must complete payment within 30 days to activate your membership.",
      uploadTitle: "Upload Proof of Payment",
      uploadHint: "Bank transfer receipt, screenshot or PDF (max 10MB)",
      uploadButton: "Upload Payment Proof",
      uploadSuccess: "Payment proof uploaded",
      uploadSuccessDesc: "The finance department will verify your payment, usually within about 3 working days.",
      uploadedConfirmation: "Payment proof uploaded — under review",
      cardPaymentTitle: "Pay by Credit Card",
      cardPaymentHint: "Request a secure payment link from the finance department",
      requestLink: "Request Credit Card Payment Link",
      payByCard: "Pay by Credit Card",
      linkRequested: "Request sent",
      linkRequestedDesc: "The finance department will send you a payment link shortly.",
      note: "If you have already uploaded your proof of payment, no further action is needed.",
      proofRejectedTitle: "We could not verify your payment proof",
      proofRejectedHelp: "Please upload a new proof of payment below. If you have a question, reply to our email or contact us.",
    },
    paymentPending: {
      title: "Payment Under Review",
      message: "Your payment proof has been received and sent to the finance department for verification. Verification usually takes about 3 working days, then about 4 working days for your membership activation and welcome letter.",
      verifying: "Verifying payment…",
      uploaded: "Uploaded",
      expected: "Expected verification",
      uploadDate: "Upload date",
      expectedDate: "Expected by",
      activationDate: "Activation around",
      note: "These are usual timings (about 7 working days in total). They can vary with when the payment is credited and with the finance workload.",
      verifiedTitle: "Payment verified",
      verifiedMessage: "Your payment has been verified. Your membership is now being issued: your welcome letter usually follows within about 4 working days.",
      addTitle: "Add another payment document",
      addHint: "If the finance department asks for more, or you have a bank statement, debit advice or SWIFT MT103, add it here. All your documents are kept together for verification.",
      addButton: "Add a document",
      added: "Document added",
      documentsTitle: "Documents sent",
    },
    paymentDone: {
      title: "Payment Validated",
      message: "Your payment has been confirmed by the finance department. You will receive your Welcome Letter and Membership Card information by email shortly.",
      verified: "Payment verified ✓",
      nextStepsTitle: "What's next?",
      step1: "You will receive your Welcome Letter by email",
      step2: "Your membership card will be prepared",
      step3: "We will contact you for visa affix appointment",
      package: "Your membership",
    },
    prePayment: {
      title: "Important notice before making payment",
      intro: "Please do not make any payment if any of the following applies to you.",
      conditions: [
        {
          title: "Entry stamp validity",
          detail: "The permission of stay shown on your passport entry stamp must be valid. An applicant with an overstay recorded during the current stay cannot obtain a Thailand Privilege visa under any circumstances.",
        },
        {
          title: "Non-Immigrant O (Volunteer) visa",
          detail: "An applicant who currently holds, or has at any time previously held, a Non-Immigrant Type O (Volunteer) visa cannot obtain a Thailand Privilege visa under any circumstances.",
        },
        {
          title: "Non-Immigrant MT or ED visa",
          detail: "An applicant currently holding a Non-Immigrant MT (Medical Treatment) visa without the required patient report from the hospital or a medical certificate, or a Non-Immigrant ED (Education) visa without the official document issued by the Office of Basic Education Commission (OBEC) and its supporting documentation, cannot obtain a Thailand Privilege visa under any circumstances.",
        },
      ],
      warning: "If any of the above applies, Thailand Privilege Card Co., Ltd. reserves the right to withhold the membership fee without issuing a refund under any circumstances.",
      rulesTitle: "Payment conditions",
      rules: [
        { text: "The membership fee must be remitted in a single transaction, in compliance with the Anti-Money Laundering Act, B.E. 2542 (1999) and its amendments. A mobile banking remittance must likewise equal the membership fee in one transaction." },
        { text: "The amount received must be the full membership fee, net of all bank charges, intermediary bank fees, agent fees and any other local or international transfer charges." },
        { text: "The letter of approval and the invoice are valid for 30 days from the date of issuance. An expired application is subject to a further background check." },
        { text: "Payment made after the due date stated on the invoice will not be accepted, and will be disqualified from any promotional offer." },
        { text: "American Express cards are not accepted." },
      ],
      doubt: "If you are unsure whether any of these conditions applies to you, contact us before paying. We can review your file first.",
    },

    visaAffix: {
      title: "Request visa affixation",
      intro: "Send the request to our team and we attach the documents we already hold on your file. We forward it to the Member Contact Center and follow the booking through.",
      locationLabel: "Where you would like the visa affixed",
      locations: {
        chaengWattana: "Chaeng Wattana Immigration Office, Bangkok",
        suvarnabhumi: "Suvarnabhumi Airport, on arrival",
        phuket: "Phuket International Airport, on arrival",
        chiangMai: "Chiang Mai International Airport, on arrival",
        overseas: "Outside Thailand (e-Visa via a Royal Thai mission)",
      },
      noticeThailand: "Appointments require 5 to 7 business days' notice and depend on Elite Personal Liaison availability.",
      noticeOverseas: "An e-Visa is issued through the official Thai government portal. Allow 15 to 30 business days from submission.",
      dateLabel: "Preferred date",
      flightLabel: "Arrival flight",
      flightPlaceholder: "e.g. TG911, 14 Oct",
      documentsLabel: "Documents on your file",
      documentsHint: "Tick what we should attach. Everything is included by default.",
      documentTypes: {
        passport_photo: "Passport",
        application_form: "Application form",
        consent_form: "Consent form",
        payment_proof: "Proof of payment",
      },
      submit: "Compose the request",
      mccTitle: "Member Contact Center",
      mccHint: "To arrange the appointment yourself instead, contact the MCC direct. Quote your membership number.",
      email: {
        subject: "Visa affixation request",
        intro: "I would like to request a Privilege Entry Visa affixation appointment.",
        member: "Member",
        card: "Membership no.",
        package: "Package",
        location: "Preferred location",
        preferredDate: "Preferred date",
        flight: "Arrival flight",
        documentsHeld: "Please attach from my file",
        noneSelected: "No documents selected",
        notSpecified: "Not specified",
        closing: "Thank you.",
      },
    },

    active: {
      title: "Welcome to Thailand Elite!",
      subtitle: "Congratulations — you are now an official Thailand Elite member.",
      cardNo: "Membership No.",
      package: "Package",
      validFrom: "Valid From",
      validUntil: "Valid Until",
      requestVisaAffix: "Request Visa Affix",
      memberArea: "Member Dashboard",
    },
    rejected: {
      title: "Application Not Approved",
      titleCancelled: "Application Cancelled",
      message: "Unfortunately, your application could not be approved at this time. If you have any questions about this decision, please contact our support team.",
      messageCancelled: "This application has been cancelled. If you wish to apply again, you can start a new application.",
      messageInactive: "This application was closed after a long period without activity. Everything you entered is saved — you can pick up where you left off.",
      resume: "Resume my application",
      resumedToast: "Welcome back! Your application is open again.",
      resumeFailed: "We could not reopen this application. Please send us a message.",
      info: "You may start a new application if you wish to apply again.",
      startNew: "Start New Application",
    },
  },

  auth: {
    login: {
      title: "Member Portal",
      subtitle: "Sign in to your account",
      email: "Email",
      continueWithEmail: "Continue with Email",
      sendingLink: "Sending link…",
      noPasswordNote: "We'll send you a secure sign-in link — no password needed.",
      noAccount: "Don't have an account?",
      createOne: "Create one",
      // Email sent state
      checkEmailTitle: "Check your email",
      checkEmailDesc: "We've sent a sign-in link to <strong>{{email}}</strong>. Click the link to access your account.",
      didntReceive: "Didn't receive it?",
      tryAgain: "Try again",
      // Account disabled state
      accountDisabledTitle: "Account Disabled",
      accountDisabledMsg: "Your account has been disabled.",
      accountDisabledReason: "Reason:",
      accountDisabledContact: "If you believe this is a mistake, please contact us at",
    },
    register: {
      title: "Create Account",
      subtitle: "Start your Thailand Elite journey",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phoneNumber: "Phone Number",
      searchCountry: "Search country…",
      continueWithEmail: "Continue with Email",
      sendingLink: "Sending magic link…",
      noPasswordNote: "We'll send you a secure link to verify your email and sign in — no password needed.",
      alreadyHaveAccount: "Already have an account?",
      signIn: "Sign in",
      // Email sent state
      checkEmailTitle: "Check your email",
      checkEmailDesc: "We've sent a magic link to <strong>{{email}}</strong>. Click the link in your email to sign in and complete your registration.",
      didntReceive: "Didn't receive it?",
      tryAgain: "Try again",
    },
  },
};
